import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const FeaturedContentBlock: BlocksView['FeaturedContentBlock'] = (props) => {
  const { id, label, image, imagePosition, title, introduction} = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section
      id={id}
      ref={ref}
      className={cn(`block block--featured featured--image-${imagePosition} ls-spacing`, inView && 'inview')}
    >
      <div className="block__inner ls-container ls-gutter">
        <div className="block__layout">
          <div className="block__content">
            <BlockHeader title={title} label={label} />

            {introduction && <div className="block__intro text--styled" dangerouslySetInnerHTML={{ __html: introduction }} />}

            <BlockActions {...props} datalayerCategory="featured_content_block" />
          </div>

          {image && (
            <div className="block__visual">
              <Img {...image} loading="lazy" className="block__image" width="510" height="510" />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
